/** @format */

import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import campaignSlice from "./slice/campaignSlice";
import ListDetailsSlice from "./slice/ListDetailsSlice";
import userSlice from "./slice/userSlice";
import { secureSessionStorage } from "../utils/storageCrypto";

const campaignConfig = {
  key: "campaign",
  storage: secureSessionStorage,
  whitelist: ["formValue"],
};
const ListDetailsConfig = {
  key: "listDetails",
  storage: secureSessionStorage,
  whitelist: [],
};
const UserConfig = {
  key: "user",
  storage: secureSessionStorage,
  whitelist: ["user", "adminDetails", "clientBrands"],
};

const persistConfigReducer = persistReducer(campaignConfig, campaignSlice);
const persistConfigList = persistReducer(ListDetailsConfig, ListDetailsSlice);
const persistConfigUser = persistReducer(UserConfig, userSlice);

export const store = configureStore({
  reducer: {
    campaign: persistConfigReducer,
    listDetails: persistConfigList,
    user: persistConfigUser,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persist = persistStore(store);
